import PriceDisplay from '@/components/PriceDisplay';
import { TransText } from '@/i18n/trans/text';
import type { FeeDTO } from '@/types/dto/agent';
import { typedEntries } from '@/utils/object';
import { Icons, Typography } from '@fleet/webshop-ui';
import { type FC, useMemo } from 'react';

interface VouchersProps {
  fees: Array<FeeDTO>;
}

const Fees: FC<VouchersProps> = ({ fees }) => {
  const feesMap = useMemo(
    () =>
      fees.reduce<Partial<Record<NonNullable<FeeDTO['type']>, number>>>(
        (acc, current) => {
          if (!current.type) {
            return acc;
          }

          const amount = current.price?.amount ?? 0;
          acc[current.type] = (acc[current.type] || 0) + amount;

          return acc;
        },
        {}
      ),
    [fees]
  );

  return (
    <>
      <div className="flex gap-2 bg-primary-pale px-4 py-3">
        <Icons.travelPass className="h-5 w-5 text-primary" />
        <Typography variant="body1-bold">
          <TransText i18nKey="additionalFees" />
        </Typography>
      </div>
      <div className="flex flex-col gap-2 p-4">
        {typedEntries(feesMap).map(([type, amount], key) => (
          <div className="flex justify-between" key={key}>
            <div className="flex gap-2">
              <Icons.ticket className="text-primary" />
              <Typography variant="body2-bold">
                <TransText i18nKey={type} />
              </Typography>
            </div>
            <Typography variant="body2-bold" className="text-primary">
              <PriceDisplay amount={amount} />
            </Typography>
          </div>
        ))}
      </div>
    </>
  );
};

export default Fees;
